import { createContext } from 'react';

import type { FocusFallbacks } from './types';

export const FocusFallbackContext = createContext<{ fallbacks: FocusFallbacks } | undefined>(undefined);
